import { getEmergencyData as h } from './contact-channels41.js';
import { useQuery as m } from './contact-channels42.js';
import { useContactChannelsContext as z } from './contact-channels19.js';

const u=(e=true)=>{const{tenant:t,locale:r}=z();return m({queryKey:["emergency"],queryFn:()=>h(t,r),staleTime:1/0,gcTime:1/0,enabled:e,retry:3})};

export { u as useEmergencyCheck };
//# sourceMappingURL=contact-channels2.js.map
